import { register } from "@rill/loader";
const fs = require("fs");
const path = require("path");
register(
  {
    name: "iconList",
    meta: ["no-bust", "icons"],
    ttl: "2 hours",
  },

  async () => {
    const iconFolder = path.join(__dirname, "../../img/new-icons");

    const iconFiles = fs.readdirSync(iconFolder);

    return iconFiles;
  }
);
